import { Component, OnInit, Input } from '@angular/core';
interface User {
  count: number;
  idPhotoUrl: string;
  locationName: string;
  userDateOfBirth: string;
  userEmail1: string;
  userEmail2: string;
  userHomeAreaDetails: string;
  userId: number;
  userIdNumber: string;
  userIdType: string;
  userName: string;
  userPhone1: string;
  userPhone2: string;
  userPhotoUrl: string;
  userRecruitmentDate: string;
  userStatus: number;
}
@Component({
  selector: 'app-users-report',
  templateUrl: './users-report.component.html',
  styleUrls: ['./users-report.component.scss']
})
export class UsersReportComponent implements OnInit {

  constructor() { }
  @Input() itm: User;
  ngOnInit(): void {
  }

}
